import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ErrorContainer = styled.span<{ cursorPointer: boolean }>(props => ({
    color: theme(props).semanticColors.action.color,
    backgroundColor: theme(props).semanticColors.danger.backgroundColor,

    height: 24,
    paddingTop: 4,
    paddingBottom: 5,
    cursor: props.cursorPointer ? "cursor" : undefined,

    ":hover": {
        backgroundColor: theme(props).semanticColors.danger.backgroundColor,
        color: theme(props).semanticColors.action.color,
    },
}));
